export const USER_ROLES = Object.freeze({
  STUDENT: "STUDENT",
  TEACHER: "TEACHER",
  ADMIN: "ADMIN",
  MODERATOR:"MODERATOR"
});
